import React from 'react';

import { RowWrapper } from './styles';

class Row extends React.PureComponent {
    render() {
        const {
            stretch,
            cols,
            children,
            order,
            styledRowIn,
            singleProduct,
            styledRow,
            multipleProducts,
        } = this.props;
        return (
            <RowWrapper
                stretch={stretch}
                singleProduct={singleProduct}
                styledRow={styledRow}
                multipleProducts={multipleProducts}
                styledRowIn={styledRowIn}
            >
                {React.Children.map(children, (child, i) => {
                    return React.cloneElement(child, {
                        cols: cols.reduce((a, b) => a + b),
                        width: cols[i],
                        order,
                    });
                })}
            </RowWrapper>
        );
    }
}

export default Row;
